import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { baseUrl } from '.'

const url = `${baseUrl}/${import.meta.env.VITE_HELPDESK_API}`

export type SendHelpdeskEmailRequest = {
  name: string
  email: string
  phone: string
  subject: string
  message: string
  product?: number
}

export const sendHelpdeskEmail = (data: SendHelpdeskEmailRequest) => {
  return apiClient.post(`${url}/SendHelpdeskEmail`, data)
}
